
import styled from 'styled-components';

export const Container = styled.div`
  position:fixed;
  bottom: 15px;
  right: 15px;
  z-index: 5;
`;

export const IconButton = styled.div`
  width:60px;
  height:60px;
  border-radius: 100%;
  background: #006747;
  box-shadow: 2px 2px 2px #aaaaaa;
  cursor:pointer;
`;

export const ButtonFloating = styled.div`
  transform: scale(0.4);
  transition: all 500ms ease-in-out;
`

export const Icon = styled.div`
  display:flex; 
  align-items:center;
  justify-content:center;
  height: 100%;
  transition: all .5s;
`
type ButtonProps = {
  showMenu: boolean;
}

export const Options = styled.ul<ButtonProps>`
  list-style-type: none;
  position: absolute;
  bottom: 70px;
  right: -5px;
  opacity: ${props => props.showMenu ? 1 : 0};
  transition:all 0.3s;
  transform:${props => props.showMenu ? 'scale(1)' : 'scale(0)'};
  transform-origin: 80% bottom;

  li {
    display:flex;
    justify-content:flex-end;
    padding:5px;
  }
`

export const Label = styled.div`
  padding: 2px 5px;
  margin-right: 10px;
  align-self: center;
  user-select:none;
  background-color: #006747;
  color:yellow;
  border-radius: 3px;
  box-shadow: 2px 2px 2px #aaaaaa;
`